module.exports = __webpack_public_path__ + "static/media/VanessaTabbertResume.e293e59d.pdf";